import { MakeLogicType, actions, connect, events, kea, listeners, path, reducers, selectors } from 'kea'

import { teamLogic } from 'scenes/teamLogic'

import type { TeamPublicType, TeamType } from '../../../types'

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface filterTestAccountsDefaultsLogicValues {
    currentTeam: TeamPublicType | TeamType | null // teamLogic
    filterTestAccountsDefault: boolean
    localFilterTestAccountsDefault: boolean | null
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface filterTestAccountsDefaultsLogicActions {
    setDefault: (value: boolean) => {
        value: boolean
    }
    setLocalDefault: (value: boolean) => {
        value: boolean
    }
    setTeamDefault: (value: boolean) => {
        value: boolean
    }
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface filterTestAccountsDefaultsLogicMeta {
    __keaTypeGenInternalSelectorTypes: {
        filterTestAccountsDefault: (
            localFilterTestAccountsDefault: boolean | null,
            currentTeam: TeamPublicType | TeamType | null
        ) => boolean
    }
}

export type filterTestAccountsDefaultsLogicType = MakeLogicType<
    filterTestAccountsDefaultsLogicValues,
    filterTestAccountsDefaultsLogicActions,
    Record<string, any>,
    filterTestAccountsDefaultsLogicMeta
>

export const filterTestAccountsDefaultsLogic = kea<filterTestAccountsDefaultsLogicType>([
    path(['scenes', 'project', 'Settings', 'filterTestAccountsDefaultLogic']),
    connect(() => ({
        values: [teamLogic, ['currentTeam']],
    })),
    actions({
        setDefault: (value: boolean) => ({ value }),
        setTeamDefault: (value: boolean) => ({ value }),
        setLocalDefault: (value: boolean) => ({ value }),
    }),
    reducers({
        localFilterTestAccountsDefault: [
            null as null | boolean,
            {
                setDefault: (_, { value }) => value,
                setTeamDefault: (_, { value }) => value,
                setLocalDefault: (_, { value }) => value,
            },
        ],
    }),
    selectors({
        filterTestAccountsDefault: [
            (s) => [s.localFilterTestAccountsDefault, s.currentTeam],
            (
                localFilterTestAccountsDefault: boolean | null,
                currentTeam: null | import('../../../types').TeamPublicType | import('../../../types').TeamType
            ) => {
                if (localFilterTestAccountsDefault !== null) {
                    return localFilterTestAccountsDefault
                } else if (currentTeam?.test_account_filters_default_checked) {
                    return currentTeam?.test_account_filters_default_checked
                }
                return false
            },
        ],
    }),
    listeners({
        setTeamDefault: ({ value }) => {
            localStorage.setItem('default_filter_test_accounts', value.toString())
        },
        setLocalDefault: ({ value }) => {
            localStorage.setItem('default_filter_test_accounts', value.toString())
        },
    }),
    events(({ actions }) => ({
        afterMount: () => {
            if (localStorage.getItem('default_filter_test_accounts') !== null) {
                actions.setDefault(localStorage.getItem('default_filter_test_accounts') === 'true')
            }
        },
    })),
])
